/**
 * Created by slava on 02.02.17.
 */

const KingsCupCell = function (x, y) {
    BaseCell.call(this, x, y);
    this.movable = true;
    this.putInPoolAvailable = true;
};

KingsCupCell.prototype = Object.create(BaseCell.prototype);
KingsCupCell.prototype.constructor = KingsCupCell;

KingsCupCell.prototype.getViewClass = function () {
    return KingsCupCellView;
};

KingsCupCell.prototype.save = function () {
    return KingsCupCell.CODES;
};

KingsCupCell.prototype.load = function () {
};

KingsCupCell.prototype.boom = function () {
    this.hurt();
};

KingsCupCell.isNeedToAdd = function (moves, levelMoves) {
    const game = Game.currentGame;

    if (!game || !game.kingsCupMission || levelMoves - moves <= 2) {
        return false;
    }

    let amount = 0;

    for (let i = 0; i < Field.SIZE; i++) {
        for (let j = 0; j < Field.SIZE; j++) {
            const cell = game.field.cells[i][j];
            if (cell && cell.constructor === KingsCupCell) {
                amount++;
            }
        }
    }

    for (let i = 0; i < game.field.nextCells.length; i++) {
        if (game.field.nextCells[i] === KingsCupCell.CODES[0]) {
            amount++;
        }
    }

    return Math.random() < 0.3 - 0.1 * amount;
};
